import { z } from "zod";

/**
 * Extra data for miss mary passed via the custom route loader.
 */
export const loaderCustomExtraDataSchema = z.object({
  url: z.string(),
  headers: z.tuple([z.string(), z.string()]).array(),
  shouldNoIndex: z.boolean(),
});

export type MmLoaderCustomExtraData = z.infer<
  typeof loaderCustomExtraDataSchema
>;

export const getLoaderCustomExtraDataOrNull = (
  customExtraData: unknown,
): MmLoaderCustomExtraData | null => {
  if (!customExtraData) {
    return null;
  }

  const customExtraDataResult =
    loaderCustomExtraDataSchema.safeParse(customExtraData);
  if (!customExtraDataResult.success) {
    console.error(
      "Custom extra data is not valid",
      customExtraDataResult.error.format(),
    );
    return null;
  }

  return customExtraDataResult.data;
};
